import React from 'react';
import RecordLandlord from '~pages/pms-dashboard/properties/record/record-landlord';
import {
  ContractEmptyLandlord as ContractEmptyLandlordIcon,
  ContractRecordLandlord as ContractRecordLandlordIcon,
} from 'common/components/svgs';
import { useTranslation } from 'react-i18next';

export default function ContractCategory(props) {
  const { landlordContract, propertyContract } = props;
  const { t } = useTranslation();
  return (
    <div className="contract-category-container">
      <Choose>
        <When condition={!landlordContract.length && !propertyContract.length}>
          <div className="contract-category-container__empty-container">
            <ContractEmptyLandlordIcon className="contract-category-container__empty-icon" />
            <div className="contract-category-container__empty-header">
              {t('cms:cms.property.record_landlord.empty.header')}
            </div>
            <div className="contract-category-container__empty-description">
              {t('cms:cms.property.record_landlord.empty.description')}
            </div>
          </div>
        </When>
        <Otherwise>
          <div className="contract-category-container__banner-container">
            <ContractRecordLandlordIcon className="contract-category-container__uploaded-icon" />
            <div className="contract-category-container__uploaded-header">
              {t('cms:cms.property.record_landlord.uploaded.header')}
            </div>
            <div className="contract-category-container__uploaded-description">
              {t('cms:cms.property.record_landlord.uploaded.description')}
            </div>
          </div>

          <div className="contract-category-container__contract-wrap">
            <p className="contract-category-container__contract-des">
              {t('cms:cms.property.record.update_contract.file_title')}
            </p>
            <RecordLandlord belongTo="property" t={t} fileArray={propertyContract} />
            <RecordLandlord belongTo="landlord" t={t} fileArray={landlordContract} />
          </div>
        </Otherwise>
      </Choose>
    </div>
  );
}
